/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SmsAggregator {
  NotValid = 0,
  MCI = 1,
  Irancell = 2,
  Rightel = 3,
  Other = 4,
  International = 5
}
